export default __webpack_public_path__ + "static/media/Visa Discovery Logo desktop.0b3ad58c.png";